"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.Loader = exports.StyledContent = exports.rgba = void 0;
const loader_1 = __importDefault(require("@kawaui/loader"));
const styled_components_1 = __importStar(require("styled-components"));
const getSizeStyle = (size) => {
    switch (size) {
        case 'small':
            return smallText;
        case 'large':
            return largeText;
        case 'medium':
        default:
            return mediumText;
    }
};
const rgba = (color, alpha) => {
    if (alpha < 0 || alpha > 1)
        return '';
    const colorRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    const match = color.match(colorRegex);
    if (!match)
        return '';
    const hex = match[1].length === 3 ? match[1].replace(/./g, '$&$&') : match[1];
    const [r, g, b] = [0, 2, 4].map((offset) => parseInt(hex.substring(offset, offset + 2), 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
exports.rgba = rgba;
const getVariantStyle = (variant) => {
    switch (variant) {
        case 'primary':
        default:
            return primaryStyle;
        case 'secondary':
            return secondaryStyle;
        case 'tertiary':
            return tertiaryStyle;
        case 'transparent':
            return transparentStyle;
        case 'text':
            return textStyle;
    }
};
exports.StyledContent = styled_components_1.default.div `
  ${({ isLoading }) => isLoading &&
    (0, styled_components_1.css) `
      color: transparent;
      height: 0;
    `}
`;
exports.Loader = (0, styled_components_1.default)(loader_1.default) `
  /* box model */
  width: 100%;
  height: 100%;

  /* color */
  circle {
    stroke: currentColor;
  }
`;
exports.StyledButton = styled_components_1.default.button `
  /* box model */
  border-radius: ${({ theme }) => theme.radius.s100};
  border: 1px solid;
  outline: 0;
  overflow: hidden;
  padding: ${({ theme: { space } }) => `${space.s050} ${space.s200}`};
  ${({ isFullWidth }) => isFullWidth && 'width: 100%'};

  /* text */
  ${({ size }) => getSizeStyle(size)};
  white-space: nowrap;

  /* other */
  cursor: pointer;
  transition-property: background-color, border-color, color;
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;

  ${({ variant }) => (0, styled_components_1.css) `
    ${getVariantStyle(variant)}
    ${variant !== 'text' && loadingStyle}
  `};

  &:disabled {
    /* other */
    cursor: not-allowed;

    ${({ theme: { colors } }) => (0, styled_components_1.css) `
      /* color */
      background-color: ${colors.gray.s200};
      border-color: ${colors.gray.s200};
      color: ${colors.gray.s650};
    `}
  }
`;
const loadingStyle = (0, styled_components_1.css) `
  ${({ theme: { colors }, isLoading }) => isLoading &&
    (0, styled_components_1.css) `
      /* color */
      background-color: ${colors.main.tap};
      border-color: ${colors.main.tap};
      color: ${colors.text.alternate.body};

      /* other */
      cursor: not-allowed;

      @media (hover: hover) {
        &:hover {
          background-color: ${colors.main.tap};
          border-color: ${colors.main.tap};
          color: ${colors.text.alternate.body};
        }
      }
    `}
`;
const primaryStyle = (0, styled_components_1.css) `
  ${({ theme: { colors } }) => (0, styled_components_1.css) `
    /* color */
    background-color: ${colors.main.base};

    border-color: ${colors.main.base};
    color: ${colors.text.alternate.body};
    @media (hover: hover) {
      &:hover {
        background-color: ${colors.main.hover};
        border-color: ${colors.main.hover};
        color: ${colors.text.alternate.body};
      }
    }
    &:active {
      background-color: ${colors.main.tap};
      border-color: ${colors.main.tap};
      color: ${colors.text.alternate.body};
    }
  `}
`;
const secondaryStyle = (0, styled_components_1.css) `
  ${({ theme: { colors } }) => (0, styled_components_1.css) `
    /* color */
    background-color: transparent;
    border-color: ${colors.main.base};
    color: ${colors.main.base};
    @media (hover: hover) {
      &:hover {
        background-color: ${colors.main.hover};
        border-color: ${colors.main.hover};
        color: ${colors.text.alternate.body};
      }
    }
    &:active {
      background-color: ${colors.main.tap};
      border-color: ${colors.main.tap};
      color: ${colors.text.alternate.body};
    }
  `}
`;
const tertiaryStyle = (0, styled_components_1.css) `
  ${({ theme: { colors } }) => (0, styled_components_1.css) `
    /* color */
    background-color: transparent;
    border-color: ${colors.gray.s300};
    color: ${colors.text.body};
    @media (hover: hover) {
      &:hover {
        background-color: transparent;
        border-color: ${colors.main.base};
        color: ${colors.main.base};
      }
    }
    &:active {
      background-color: ${colors.main.tap};
      border-color: ${colors.main.tap};
      color: ${colors.text.alternate.body};
    }
  `}
`;
const transparentStyle = (0, styled_components_1.css) `
  ${({ theme: { colors } }) => (0, styled_components_1.css) `
    /* color */
    border-radius: ${({ theme }) => theme.radius.s100};
    border: 1px solid ${({ theme }) => theme.colors.white.s100};
    color: ${({ theme }) => theme.colors.white.s100};
    background-color: rgba(255, 255, 255, 0.2);

    @media (hover: hover) {
      &:hover {
        background-color: rgba(255, 255, 255, 0.4);
      }
    }
    &:active {
      background-color: rgba(255, 255, 255, 0.6);
    }

    &:focus {
      box-shadow: 0 0 0 4px ${(0, exports.rgba)(colors.main.base, 0.4)};
    }

    &:disabled {
      background-color: rgba(255, 255, 255, 0.6);
      border-color: ${({ theme }) => theme.colors.gray.s650};
      color: ${({ theme }) => theme.colors.gray.s650};
    }
  `}
`;
const textStyle = (0, styled_components_1.css) `
  background-color: transparent;
  border-color: transparent;
  color: ${({ theme }) => theme.colors.text.body};

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.main.hover};
    }
  }
  &:active {
    color: ${({ theme }) => theme.colors.main.base};
  }

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.smallText)};
`;
const smallText = (0, styled_components_1.css) `
  /* box model */
  height: 2rem;

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.smallTextMain)};
`;
const mediumText = (0, styled_components_1.css) `
  /* box model */
  height: 2.5rem;

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.textMain)};
`;
const largeText = (0, styled_components_1.css) `
  ${mediumText};
  height: 3rem;
`;
